import { createPortal } from 'react-dom';
import { RootState } from '../../../Redux/Store';
import { useAppSelector } from '../../../Hooks/Hooks';
import { TCustomLoaderProps } from './CustomLoader.type';
import './CustomLoader.scss';

const CustomLoader = (props: TCustomLoaderProps) => {
  const loading = useAppSelector((state: RootState) => state?.global?.loading);
  if (!loading) return null;
  return createPortal(
    <div className="CustomLoader">
      <div className="backdrop" />
      <img src="/oo/assets/images/Schneider_Spinner-transparent.gif" alt="" className="Loader" />
    </div>,
    document.getElementById('loader') as HTMLElement,
  );
};
export default CustomLoader;
